import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different exercise action types
*/
let initialstate = { isLoading: false, exercises: [] }
export default function exercise_operations(
  state = { ...initialstate },
  action
) {
  switch (action.type) {
    case ActionType.EXER_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.EXER_SET_EXERCISES:
      return { ...state, exercises: action.exercises }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
